// components/NewsletterSignup.jsx
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../api/axios";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // simple email regex
  const isValidEmail = (email) => /^\S+@\S+\.\S+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) return;

    setLoading(true);
    try {
      await api.post("/subscribers", { email });
      toast.success("Thank you for subscribing to our newsletter!");
      setEmail("");
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Subscription failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-accent max-w-6xl mx-auto text-center px-4 -mt-60 py-[42px] rounded-t-3xl z-40">
      <h3 className="text-base sm:text-lg md:text-xl lg:text-2xl font-semibold mb-4">
        Join our community of 10,000+ car enthusiasts
      </h3>

      <form
        onSubmit={handleSubmit}
        className="relative mx-auto w-full md:w-[500px]"
      >
        <input
          type="email"
          placeholder="Enter email here"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full h-14 pr-32 pl-6 rounded-full text-black outline-none shadow-md"
        />

        <button
          type="submit"
          disabled={!isValidEmail(email) || loading}
          className={`absolute right-1 top-1 bottom-1 px-6 rounded-full text-white font-semibold
            ${
              isValidEmail(email) && !loading
                ? "bg-primary hover:bg-primary-dark"
                : "bg-gray-400 cursor-not-allowed"
            }`}
        >
          {loading ? "…" : "Subscribe"}
        </button>
      </form>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
